import TextField from "@mui/material/TextField";
import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { InputBase, TextareaAutosize } from "@mui/material";
import { PatientColorMap } from "../../layout/patientColorMap";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

const inputStyle = {
  width: "100%",
  marginBottom: "5px",
  padding: "5px",
  "& input[type='text']:focus, & input[type='email']:focus, & input[type='url']:focus, & input[type='password']:focus, & input[type='search']:focus, & input[type='number']:focus, & input[type='tel']:focus, & input[type='range']:focus, & input[type='date']:focus & input[type='month']:focus, & input[type='week']:focus, & input[type='time']:focus, & input[type='datetime']:focus, & input[type='datetime-local']:focus, & input[type='color']:focus, & textarea:focus": {
    color: KahunColorMap.BlackPatientFacing,
  },
  "& input, & input[type='text'], & input[type='email'], & input[type='url'], & input[type='password'], & input[type='search'], & input[type='number'], & input[type='tel'], & input[type='range'], & input[type='date'], & input[type='month'], & input[type='week'], & input[type='time'], & input[type='datetime'], & input[type='datetime-local'], & input[type='color']": {
    background: "transparent",
    border: "none",
    height: "auto",
    margin: 0,
    color: KahunColorMap.BlackPatientFacing,
  },
  "& fieldset": {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    display: "block",
    "& legend span": {
      color: KahunColorMap.BlackPatientFacing,
    },
  },
};

export const PatientInput = styled(InputBase)({
  borderRadius: "14px",
  border: `1px solid ${PatientColorMap.DefaultDark}`,
  width: "auto",
  padding: "5px",
  background: PatientColorMap.White,
  fontSize: "16px",
  minWidth: "42px",
  "& input": {
    textAlign: "left",
    ...onRtl({
      textAlign: "right",
    }),
    padding: "0 7px",
    border: "none",
    background: "transparent",
    color: KahunColorMap.BlackPatientFacing,
  },
});

export const PatientTextField = styled(TextField)(inputStyle);
export const PatientTextAreaField = styled(TextareaAutosize)({
  ...inputStyle,
  border: `solid 1px ${PatientColorMap.DefaultDark}`,
});
